import { MediaMatcher } from '@angular/cdk/layout';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Breakpoint } from '@app/types/breakpoint.enum';

@Injectable({
  providedIn: 'root',
})
export class PanelService {
  private readonly media = inject(MediaMatcher);

  private readonly _rightPanelVisibility = new BehaviorSubject<boolean>(false);
  readonly rightPanelVisibility$ = this._rightPanelVisibility.asObservable();

  #mobileQuery: MediaQueryList;

  constructor() {
    this.#mobileQuery = this.media.matchMedia(`(max-width: ${Breakpoint.medium})`);
  }

  toggleRightPanelVisibility(visible?: boolean): void {
    this._rightPanelVisibility.next(visible ?? !this._rightPanelVisibility.value);
  }
}
